import React from 'react';
import cn from 'clsx';

import styles from './fitment-size-group.scss';

interface FitmentSizeGroupProps {
  className?: string;
}

function FitmentSizeGroup(
  props: React.PropsWithChildren<FitmentSizeGroupProps>
) {
  const { children, className = '' } = props;

  return (
    <div className={cn(styles['container'], `fitment-size-group ${className}`)}>
      {children}
    </div>
  );
}

export default FitmentSizeGroup;
